import { EnumResolver } from "../../../../common/tables/etc/EnumResolver";
import { PLPRTableRow } from "../../../../../../common/tables/product-listing/payout-rule-mapping/PLPRTableRow";
import { EnumMapper } from "../../../../common/tables/etc/EnumMapper";

export class PLPREnumMapper extends EnumResolver<PLPRTableRow> {
    public resolveEnum(_columnName: keyof PLPRTableRow): EnumMapper {
        return {} as EnumMapper;
    }
}
